<template>
  <QCard flat bordered>
    <QCardSection class="q-pa-lg row">
      <div class="row col items-center">
        {{ addressString }}
      </div>
      <QBtn
        flat
        round
        size="sm"
        icon="eva-edit-outline"
        @click="$emit('edit')"
      />
    </QCardSection>
  </QCard>
</template>

<script>
import { QCard, QCardSection, QBtn } from 'quasar';
import AddressFilter from '@eui-filter/address';

export default {
  name: 'SAIAddressCard',
  props: {
    address2: {
      type: String
    },
    streetNumber: {
      type: String
    },
    address: {
      type: String
    },
    suburb: {
      type: String
    },
    postCode: {
      type: String
    },
    state: {
      type: String
    },
    countryCode: {
      type: String
    }
  },
  computed: {
    addressString() {
      return AddressFilter({
        address2: this.address2,
        streetNumber: this.streetNumber,
        address: this.address,
        suburb: this.suburb,
        postCode: this.postCode,
        state: this.state,
        countryCode: this.countryCode
      });
    }
  },
  components: {
    QCard,
    QCardSection,
    QBtn
  }
};
</script>
